/**
 * All beacon / conduct roles used by the UI
 */
export enum ERole {
  // Please keep in alphabetical order to keep things easy to find
  ADM_REQ_INFO = 'ROLE_CONDUCT_ADM_REQ_INFO',
  APPEAL_COURT_QUEUE = 'ROLE_CONDUCT_APPEAL_COURT_QUEUE',
  APPEALED_QUEUE = 'ROLE_CONDUCT_APPEALED_QUEUE',
  ASSIGNED_QUEUE = 'ROLE_CONDUCT_ASSIGNED_QUEUE',
  CARE_REVIEW_QUEUE = 'ROLE_CONDUCT_CARE_REVIEW_QUEUE',
  CASE_MANAGEMENT_QUEUE = 'ROLE_CONDUCT_CASE_MANAGEMENT_QUEUE',
  CLERY_OFFICER = 'ROLE_CONDUCT_CLERY_OFFICER',
  CONCEALED = 'ROLE_CONDUCT_CONCEALED',
  CSA = 'ROLE_CONDUCT_CSA',
  DELETE_COMMENTS = 'ROLE_CONDUCT_DELETE_COMMENTS',
  DELETE_UPLOADS = 'ROLE_CONDUCT_DELETE_UPLOADS',
  DETAIL = 'ROLE_CONDUCT_DETAIL',
  DOS_INFORMATIONAL_SUBMIT = 'ROLE_CONDUCT_INFORMATIONAL_SUBMIT',
  EDIT_ASSIGNED_NARRATIVE = 'ROLE_CONDUCT_EDIT_ASSIGNED_NARRATIVE',
  EDIT_COMMENTS = 'ROLE_CONDUCT_EDIT_COMMENTS',
  EDIT_NARRATIVE = 'ROLE_CONDUCT_EDIT_NARRATIVE',
  ENFORCE_PRIVACY = 'ROLE_CONDUCT_ENFORCE_PRIVACY',
  EXPUNGE_RECORD = 'ROLE_CONDUCT_EXPUNGE_RECORD',
  ENABLE_OCL_SUBTYPES = 'ROLE_CONDUCT_ENABLE_OCL_SUBTYPES',
  FINAL_REVIEW_QUEUE = 'ROLE_CONDUCT_FINAL_REVIEW_QUEUE',
  GRADE_APPEALS_EX = 'ROLE_CONDUCT_GRADE_APPEALS_EX',
  GROUP_ADMISSIONS = 'ROLE_CONDUCT_GROUP_ADMISSIONS',
  GROUP_CARE = 'ROLE_CONDUCT_GROUP_CARE',
  GROUP_COMPLAINTS = 'ROLE_CONDUCT_GROUP_COMPLAINTS',
  GROUP_COMPLAINTS_EX = 'ROLE_CONDUCT_GROUP_COMPLAINTS_EX',
  GROUP_CONDUCT = 'ROLE_CONDUCT_GROUP_CONDUCT',
  GROUP_COUNSELING = 'ROLE_CONDUCT_GROUP_COUNSELING',
  GROUP_CSER_GRADE_APPEALS = 'ROLE_CONDUCT_GROUP_CSER_GRADE_APPEALS',
  GROUP_DOS_INFORMATIONAL = 'ROLE_CONDUCT_GROUP_DOS_INFORMATIONAL',
  GROUP_GRADE_APPEALS = 'ROLE_CONDUCT_GROUP_GRADE_APPEALS',
  GROUP_HONOR_CODE = 'ROLE_CONDUCT_GROUP_HONOR_CODE',
  GROUP_LAW_INFORMATIONAL = 'ROLE_CONDUCT_GROUP_LAW_INFORMATIONAL',
  GROUP_LAW_VIOLATIONS = 'ROLE_CONDUCT_GROUP_LAW_VIOLATIONS',
  GROUP_LUOA_CLUBS = 'ROLE_CONDUCT_GROUP_LUOA_CLUBS',
  GROUP_LUOA_COMPLAINTS = 'ROLE_CONDUCT_GROUP_LUOA_COMPLAINTS',
  GROUP_LUOA_HONOR_CODE = 'ROLE_CONDUCT_GROUP_LUOA_HONOR_CODE',
  GROUP_OGSA_HONOR_CODE = 'ROLE_CONDUCT_GROUP_OGSA_HONOR_CODE',
  GROUP_OGSA_PERSONAL = 'ROLE_CONDUCT_GROUP_OGSA_PERSONAL',
  GROUP_OMBUDSMAN = 'ROLE_CONDUCT_GROUP_OMBUDSMAN',
  GROUP_REG_OVERRIDES = 'ROLE_CONDUCT_GROUP_REG_OVERRIDES',
  GROUP_RESIDENT_SAO = 'ROLE_CONDUCT_GROUP_RESIDENT_SAO',
  GROUP_SCHOLARSHIP_APPEALS = 'ROLE_CONDUCT_GROUP_SCHOLARSHIP_APPEALS',
  GROUP_SPIRITUAL_ACCOUNTING = 'ROLE_CONDUCT_GROUP_SPIRITUAL_ACCOUNTING',
  GROUP_TITLE_IX = 'ROLE_CONDUCT_GROUP_TITLE_IX',
  IN_PROGRESS_QUEUE = 'ROLE_CONDUCT_IN_PROGRESS_QUEUE',
  INFO_RECEIVED_QUEUE = 'ROLE_CONDUCT_INFO_RECEIVED_QUEUE',
  INTENTIONAL_INTERACTION_SUBMIT = 'ROLE_CONDUCT_INTENTIONAL_INTERACTION_SUBMIT',
  IR_SUBMIT = 'ROLE_CONDUCT_IR_SUBMIT',
  LUO_STUDENT = 'ROLE_CONDUCT_LUO_STUDENT',
  LUOA_STUDENT = 'ROLE_CONDUCT_LUOA_STUDENT',
  LUOA_FACULTY = 'ROLE_CONDUCT_LUOA_FACULTY',
  LUOA_EXTENSIONS = 'ROLE_CONDUCT_GROUP_LUOA_EXTENSIONS',
  LUOA_EXTENSIONS_SUBMIT = 'ROLE_CONDUCT_LUOA_EXTENSIONS_SUBMIT',
  LUOA_APPEALS = 'ROLE_CONDUCT_GROUP_LUOA_APPEALS',
  LUOA_APPEALS_SUBMIT = 'ROLE_CONDUCT_LUOA_APPEALS_SUBMIT',
  LUOA_PROXY = 'ROLE_CONDUCT_LUOA_PROXY',
  MAINTENANCE = 'ROLE_CONDUCT_MAINTENANCE',
  NEEDS_INFO_QUEUE = 'ROLE_CONDUCT_NEEDS_INFO_QUEUE',
  OPEN_QUEUE_ADMISSIONS = 'ROLE_CONDUCT_OPEN_QUEUE_ADMISSIONS',
  OPEN_QUEUE_COMPLAINTS = 'ROLE_CONDUCT_OPEN_QUEUE_COMPLAINTS',
  OPEN_QUEUE_CONDUCT = 'ROLE_CONDUCT_OPEN_QUEUE_CONDUCT',
  OPEN_QUEUE_GRADE_APPEALS = 'ROLE_CONDUCT_OPEN_QUEUE_GRADE_APPEALS',
  OPEN_QUEUE_CSER_GRADE_APPEALS = 'ROLE_CONDUCT_OPEN_QUEUE_CSER_GRADE_APPEALS',
  OPEN_QUEUE_HONOR_CODE = 'ROLE_CONDUCT_OPEN_QUEUE_HONOR_CODE',
  OPEN_QUEUE_LAW_INFORMATIONAL = 'ROLE_CONDUCT_OPEN_QUEUE_LAW_INFORMATIONAL',
  OPEN_QUEUE_LAW_VIOLATIONS = 'ROLE_CONDUCT_OPEN_QUEUE_LAW_VIOLATIONS',
  OPEN_QUEUE_LUOA_CLUBS = 'ROLE_CONDUCT_OPEN_QUEUE_LUOA_CLUBS',
  OPEN_QUEUE_LUOA_COMPLAINTS = 'ROLE_CONDUCT_OPEN_QUEUE_LUOA_COMPLAINTS',
  OPEN_QUEUE_LUOA_HONOR_CODE = 'ROLE_CONDUCT_OPEN_QUEUE_LUOA_HONOR_CODE',
  OPEN_QUEUE_OGSA = 'ROLE_CONDUCT_OPEN_QUEUE_OGSA',
  OPEN_QUEUE_OMBUDSMAN = 'ROLE_CONDUCT_OPEN_QUEUE_OMBUDSMAN',
  OPEN_QUEUE_REG_OVERRIDES = 'ROLE_CONDUCT_OPEN_QUEUE_REG_OVERRIDES',
  OPEN_QUEUE_RESIDENT_SAO = 'ROLE_CONDUCT_OPEN_QUEUE_RESIDENT_SAO',
  OPEN_QUEUE_SCHOLARSHIP_APPEALS = 'ROLE_CONDUCT_OPEN_QUEUE_SCHOLARSHIP_APPEALS',
  OPEN_QUEUE_SPIRITUAL_ACCOUNTING = 'ROLE_CONDUCT_OPEN_QUEUE_SPIRITUAL_ACCOUNTING',
  OPEN_QUEUE_LUOA_EXTENSIONS = 'ROLE_CONDUCT_OPEN_QUEUE_LUOA_EXTENSIONS',
  OPEN_QUEUE_LUOA_FN_APPEALS = 'ROLE_CONDUCT_OPEN_QUEUE_LUOA_APPEALS',
  OPEN_QUEUE_CARE = 'ROLE_CONDUCT_OPEN_QUEUE_CARE',
  OGSA_FACULTY = 'ROLE_CONDUCT_OGSA_FACULTY',
  PENDING_ASSIGNMENT_QUEUE = 'ROLE_CONDUCT_PENDING_ASSIGNMENT_QUEUE',
  PENDING_INFO_QUEUE = 'ROLE_CONDUCT_PENDING_INFO_QUEUE',
  REFERRED_OUT_QUEUE = 'ROLE_CONDUCT_REFERRED_OUT_QUEUE',
  REGISTER_D_QUEUE = 'ROLE_CONDUCT_REGISTER_D_QUEUE',
  REGISTER_R_QUEUE = 'ROLE_CONDUCT_REGISTER_R_QUEUE',
  REOPEN_APPEAL = 'ROLE_CONDUCT_REOPEN_APPEAL',
  RESIDENT_STUDENT = 'ROLE_CONDUCT_RESIDENT_STUDENT',
  RESIDENT_ASSISTANT = 'ROLE_CONDUCT_RA',
  REVIEWED_QUEUE = 'ROLE_CONDUCT_REVIEWED_QUEUE',
  SEARCH = 'ROLE_CONDUCT_SEARCH',
  SPEAKUP_QUEUE = 'ROLE_CONDUCT_SPEAKUP_QUEUE',
  SPIRITUAL_ACCOUNTING_PREVIEW = 'ROLE_CONDUCT_SPIRITUAL_ACCOUNTING_PREVIEW',
  SWITCH_USER = 'ROLE_CONDUCT_SWITCH_USER',
  TEAM_REVIEW_QUEUE = 'ROLE_CONDUCT_TEAM_REVIEW_QUEUE',
  TITLE_IX_ADJUDICATION_QUEUE = 'ROLE_CONDUCT_TITLE_IX_ADJUDICATION_QUEUE',
  TITLE_IX_ALL_ADJUDICATION_QUEUE = 'ROLE_CONDUCT_TITLE_IX_ALL_ADJUDICATION_QUEUE',
  TITLE_IX_ALL_INQUIRY_QUEUE = 'ROLE_CONDUCT_TITLE_IX_ALL_INQUIRY_QUEUE',
  TITLE_IX_ALL_INVESTIGATION_QUEUE = 'ROLE_CONDUCT_TITLE_IX_ALL_INVESTIGATION_QUEUE',
  TITLE_IX_FINAL_REVIEW_QUEUE = 'ROLE_CONDUCT_TITLE_IX_FINAL_REVIEW_QUEUE',
  TITLE_IX_INQUIRY_QUEUE = 'ROLE_CONDUCT_TITLE_IX_INQUIRY_QUEUE',
  TITLE_IX_INVESTIGATION_QUEUE = 'ROLE_CONDUCT_TITLE_IX_INVESTIGATION_QUEUE',
  TITLE_IX_OFFICE = 'ROLE_CONDUCT_TITLE_IX_OFFICE',
  TITLE_IX_PREVIEW = 'ROLE_CONDUCT_TITLE_IX_PREVIEW',
  TITLE_IX_REVIEW_QUEUE = 'ROLE_CONDUCT_TITLE_IX_REVIEW_QUEUE',
  TITLE_IX_SENIOR_DEPUTY = 'ROLE_CONDUCT_TITLE_IX_SENIOR_DEPUTY',
  OCL_STAFF = 'ROLE_CONDUCT_OCL_STAFF',
  OCL_COORDINATOR = 'ROLE_CONDUCT_OCL_COORDINATOR',
  OCL_STUDENT_ASSISTANT = 'ROLE_CONDUCT_OCL_SA',
  OAI_FINAL_REVIEW_QUEUE = 'ROLE_CONDUCT_OAI_FINAL_REVIEW_QUEUE',
}
